import React from "react";

export const Header = ({ children }) => {
  return (
    <div>
      <div className="h-20 flex items-center bg-white px-4">{children}</div>
    </div>
  );
};
